$(document).ready(function() {
  
  
  $('#close_button').click(function (evt) {
    $('.PopupCountdown').hide();
    var exp_date = 1;
    var popup_cookie = $.cookie('popup');
    console.log(popup_cookie)
  })

  if ($.cookie('popup') == 'close') {
    $('.PopupCountdown').hide();
  }
  
  $.cookie('popup', 'close', {
    expires: 1
  });
  

  

  
  
  number_format = function (number, decimals, dec_point, thousands_sep) {
    number = number.toFixed(decimals);

    var nstr = number.toString();
    nstr += "";
    x = nstr.split(".");
    x1 = x[0];
    x2 = x.length > 1 ? dec_point + x[1] : "";
    var rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1)) x1 = x1.replace(rgx, "$1" + thousands_sep + "$2");

    return x1 + x2;
  };

  function getIndexByProperty(data, key, value) {
    for (var i = 0; i < data.length; i++) {
      if (data[i][key] == value) {
        return i;
      }
    }
    return -1;
  }
  
  if($('.sc-col-mobile').length > 0){
    $('.sc-col-mobile').flickity({
      // options
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left',
      contain: true
    });
  }

  if ($("#SortBy").length > 0) {
    $('[name=sort_by]').change(function(){
      const urlSearchParams = new URLSearchParams(
        window.location.search
      );

      urlSearchParams.set(this.name, this.value);
      window.location = `?${urlSearchParams}`;
    });
  }

  if ($(".filter-custom").length > 0) {
    $(".filter-group-display").hide();
    $(".filter-group[open] .filter-group-display").show();
    $(".filter-group-summary").click(function () {
      var parentFilter = $(this).parent();
      if (parentFilter.attr("open")) {
        $(this).parent().find(".filter-group-display").hide(400);
        parentFilter.removeAttr("open");
      } else {
        $(this).parent().find(".filter-group-display").show(400);
        parentFilter.attr("open", "");
      }
    });
  }

  if($('.template-collection').length > 0){
    if (jQuery(".flat-slider").length > 0) {
      let maxRange = parseInt(
          jQuery(".filter-group-display__price-range-to input").attr("max")
      );

      let currentMin = jQuery(
          ".filter-group-display__price-range-from input"
      ).val();
      let currentMax = jQuery(
          ".filter-group-display__price-range-to input"
      ).val();

      // console.log(maxRange, currentMin, currentMax)

      // console.log(number_format(maxRange, 0, ',', '.') + ' - ' + currentMin + ' - ' +  currentMax)

      jQuery("#flat-slider").slider({
        orientation: "horizontal",
        range: true,
        animate: true,
        min: 0,
        max: Number(maxRange),
        values: [Number(currentMin), Number(currentMax)],
        slide: function (event, ui) {
          if (ui.values[1] - ui.values[0] < 1) {
            return false;
          }

          // console.log(ui.values[0] + ' - ' + ui.values[1])

          jQuery(".filter-group-display__price-range-from input").val(
            ui.values[0]
          );
          jQuery(".filter-group-display__price-range-to input").val(
            ui.values[1]
          );

          var minFormat = number_format(ui.values[0], 0, ",", ".");
          var maxFormat = number_format(ui.values[1], 0, ",", ".");

          jQuery(".flex-price-range .min-price").html("IDR " + minFormat);
          jQuery(".flex-price-range .max-price").html("IDR " + maxFormat);
        },
      });
    }
  }

  var intRecommen = setInterval(() => {
    if($(".ProductItem").length > 0){
      clearInterval(intRecommen);

      $('.ColorSwatch__Radio-js').change(function(){
        var dataUnique = $(this).attr('data-unique');
        console.log(dataUnique);
        $('.radio-'+dataUnique+' .swatch--add-to-cart').attr('data-var_id', $(this).val())
        $('.radio-'+dataUnique+' .swatch--add-to-cart').attr('data-add-to-cart', $(this).val())
      })
    
      $('.swatch--add-to-cart').click(function(){    
        var swatch_id = $(this).attr("data-var_id");
        console.log(swatch_id)
        swatchAddItemToCart(swatch_id, 1);
      });
    
      function swatchAddItemToCart(variant_id, qty) {
        data = {
          "id": variant_id,
          "quantity": qty
        }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() {
            
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
    
            // $("[data-drawer-id=sidebar-cart]").trigger('click')
            $('#sidebar-cart').attr('aria-hidden', 'false');
            $('.PageOverlay').addClass('is-visible');
            $('html').addClass('no-scroll');
            $('#sidebar-cart .Drawer__Close').click(function(){
              $('#sidebar-cart').attr('aria-hidden', 'true');
              $('.PageOverlay').removeClass('is-visible');
              $('html').removeClass('no-scroll');
            })
          }  
        }); 
      
      }
    }
  }, 1000);

  if($('.template-product').length > 0){
    jQuery(".Product__Wrapper .ColorSwatch__Radio").click(function () {
      let selected_value = jQuery(this).val();
      let containtText = selected_value.split("_");
      // console.log(containtText[1])
      setTimeout(() => {
        jQuery("#ProductForm__SelectedValueColor").html(containtText[1]);
      }, 100);
    });
  }

  var matchFuncLower = function(passname){
    var minHeight = 99999;
    jQuery(passname).each(function(){
      if (jQuery(this).height() < minHeight) { minHeight = jQuery(this).height(); }
      // console.log(maxHeight)
    });

    jQuery(passname).height(minHeight);
  }

  if($('.quiz-section').length > 0){
    let ansArr = [];
    let totalQuestion = parseInt($("[name=totalQuestion]").val());
    let ansCollection = [
      {
        collection: 'ivory',
        inAnswer: 'Fair - cool'
      },
      {
        collection: 'ivory',
        inAnswer: 'Fair - neutral'
      },
      {
        collection: 'beige',
        inAnswer: 'Fair - warm'
      },
      {
        collection: 'beige',
        inAnswer: 'Light to medium - warm'
      },
      {
        collection: 'beige',
        inAnswer: 'Light to medium - neutral'
      },
      {
        collection: 'beige',
        inAnswer: 'Light to medium - cool'
      },
      {
        collection: 'honey',
        inAnswer: 'Medium - warm'
      },
      {
        collection: 'honey',
        inAnswer: 'Medium - neutral'
      },
      {
        collection: 'honey',
        inAnswer: 'Medium - cool'
      },
      {
        collection: 'tan',
        inAnswer: 'Medium to tan - warm'
      },
      {
        collection: 'tan',
        inAnswer: 'Medium to tan - neutral'
      },
      {
        collection: 'tan',
        inAnswer: 'Medium to tan - cool'
      },
      {
        collection: 'tan',
        inAnswer: 'Tan - warm'
      },
      {
        collection: 'tan',
        inAnswer: 'Tan - neutral'
      },
      {
        collection: 'tan',
        inAnswer: 'Tan - cool'
      }
    ];

    $(".next-click button").click(function(){
      let indCurrent = parseInt($(this).attr('data-current'));
      let prevCurrent = parseInt($(".prev-click button").attr('data-current'));
      let nextQuestion = indCurrent + 1;

      let question = $(".item-quiz.item-" + indCurrent + " .title-pertanyaan").html();
      let answer = $(".item-quiz.item-" + indCurrent + " .item-answer input:checked").val();

      ansArr.push({
        qestion : question,
        answer : answer
      });
      
      $(this).attr('data-current', nextQuestion);
      $(".prev-click button").attr('data-current', prevCurrent + 1);

      $(".item-quiz").hide(500);
      $(".item-quiz.item-" + nextQuestion ).show(500);

      if(prevCurrent + 1 > 0){
        $(".prev-click button").show();
      }
      else{
        $(".prev-click button").hide();
      }

      if(nextQuestion >= totalQuestion){
        $(this).hide();
        $(".submit-click").removeClass("hide");
      }

      if(jQuery(".jawaban-2").length > 0){
        matchFuncLower(".jawaban-2 img");
        console.log('comm')
      }
    })

    // $(".prev-click button").click(function(){
    //   let indCurrent = parseInt($(this).attr('data-current'));
    //   let nextCurrent = parseInt($(".next-click button").attr('data-current'));
    //   let prevQuestion = indCurrent - 1;

    //   ansArr.pop();

    //   $(this).attr('data-current', prevQuestion);
    //   $(".next-click button").attr('data-current', nextCurrent - 1);

    //   $(".item-quiz").hide(500);
    //   $(".item-quiz.item-" + indCurrent ).show(500);

    //   $(".submit-click").hide();
    //   $(".next-click button").show();
    //   if(prevQuestion == 0){
    //     $(this).hide();
    //   }
    // })

    $(".prev-click button").click(function(){
      let indCurrent = parseInt($(this).attr('data-current'));
      let prevQuestion = indCurrent - 1;
      let jawabanIndex = indCurrent + 1;

      // console.log(indCurrent)
      if($(".jawaban input:checked").length == totalQuestion){
        // ansArr.pop();
      }
      
      $(".jawaban-"+indCurrent+" input:checked").prop('checked', false);
      $(".jawaban-"+jawabanIndex+" input:checked").prop('checked', false);

      // ansArr.pop();

      $(".jawaban .loader").removeClass("hide");
      
      setTimeout(() => {
        $(".title-pertanyaan").hide();
        $(".item-answer").hide();
        $(".jawaban .loader").addClass("hide");

        $(".pertanyaan-"+indCurrent).show();
        $(".jawaban-"+indCurrent).show();

        if(prevQuestion == 0){
          $(".prev-click").addClass("hide")
        }
        $(".prev-click button").attr("data-current", prevQuestion)
        $(".submit-click").addClass("hide");
        // console.log(ansArr)
      }, 1000);

      if(jQuery(".jawaban-2").length > 0){
        matchFuncLower(".jawaban-2 img");
        // console.log('comm')
      }
    })

    $(".item-answer label").click(function(){
      let indCurrent = parseInt($(this).attr('data-current'));
      let nextCurrent = indCurrent + 1;
      let inputId = $(this).attr('for');
      let question = $(".pertanyaan-" + indCurrent).html();
      let answer = $("#"+inputId).val();
      let nextQuestion = indCurrent + 1;

      // ansArr.push({
      //   qestion : question,
      //   answer : answer
      // });

      $(".jawaban .loader").removeClass("hide");
      
      setTimeout(() => {
        $(".prev-click").removeClass("hide");
        $(".jawaban .loader").addClass("hide");

        // console.log(ansArr)
        if(indCurrent >= totalQuestion){
          $(".submit-click").removeClass("hide");
        }
        else{
          $(".pertanyaan-"+indCurrent).hide();
          $(".jawaban-"+indCurrent).hide();

          $(".pertanyaan-"+nextCurrent).show();
          $(".jawaban-"+nextCurrent).show();

          $(".prev-click button").attr("data-current", indCurrent)
        }

        if(jQuery(".jawaban-2").length > 0){
          matchFuncLower(".jawaban-2 img");
          // console.log('comm')
        }
      }, 1000);
    })

    $(".submit-click button").click(function(){
      for (let i = 1; i <= totalQuestion; i++) {
        let question = $(".pertanyaan-" + i ).html();
        let answer = $(".jawaban-" + i + " input:checked").val();
        var data = {
          question : question,
          answer : answer
        }

        var dataIndex = getIndexByProperty(ansArr, 'question', question);
        if (dataIndex > -1) {
          ansArr[dataIndex] = data;
        } else {
          ansArr.push(data);
        }
      }

      // console.log(ansArr)

      let answer1 = ansArr[0].answer.toLowerCase();
      let answer2 = ansArr[1].answer.toLowerCase().split(" (");
      
      ansCollection.forEach(el => {
        var inAnswer = el.inAnswer.toLowerCase().split(" - ")
        if(inAnswer[0] == answer1){
          if(inAnswer[1] == answer2[0]){
            // console.log(el.collection)
            $(".jawaban .loader").removeClass("hide");
            setTimeout(() => {
              $(".jawaban .loader").addClass("hide");
              $(".jawaban").addClass("hide");
              $(".submit-click").addClass("hide");
              $(".prev-click").addClass("hide");

              console.log(el.collection.charAt(0).toUpperCase() + el.collection.slice(1))
              $('.ProductItem__ColorSwatchItem').hide();
              $('.ColorSwatch__Radio-js[data-colorna="'+el.collection.charAt(0).toUpperCase() + el.collection.slice(1)+'"]').closest('div').attr('style', '');
              setTimeout(function(){
                $('.ColorSwatch__Radio-js[data-colorna="'+el.collection.charAt(0).toUpperCase() + el.collection.slice(1)+'"]').click();
              }, 1000);

              $(".collection-jawaban").removeClass("hide");
              $(".inner-collection[data-collection="+el.collection+"]").removeClass("hide");
              $(".add-all-to-cart").attr("collection-add", el.collection)
            }, 1000);
          }
        }
      });
    })

    $(".add-all-to-cart").click(function(){
      let collectionId = $(this).attr("collection-add");
      let banyakItem = $(".inner-collection[data-collection="+collectionId+"] .item-pr").length;

      var dataCart = [];
      for (let i = 1; i <= banyakItem; i++) {
        let varId = $(".inner-collection[data-collection="+collectionId+"] .item-pr.item-"+i+" .ColorSwatch__Radio-js:checked").val()
        let dataUnique = $(".inner-collection[data-collection="+collectionId+"] .item-pr.item-"+i+" .ColorSwatch__Radio-js:checked").attr("data-unique")
        // console.log($(".inner-collection[data-collection="+collectionId+"] .item-pr.item-"+i+" .swatch--add-to-cart").attr('data-var_id', $(this).val()))
        
        var data = {
          id: varId,
          quantity: 1
        }

        var dataIndex = getIndexByProperty(dataCart, 'id', varId);
        if (dataIndex > -1) {
          dataCart[dataIndex] = data;
        } else {
          dataCart.push(data);
        }
      }
      
      var cart = jQuery.post('/cart/add.js', {
        items: dataCart,
      });
    
      setTimeout(function(){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        $("[data-drawer-id=sidebar-cart]").trigger('click')
        $('#sidebar-cart').attr('aria-hidden', 'false');
        $('.PageOverlay').addClass('is-visible');
        $('html').addClass('no-scroll');
        $('#sidebar-cart .Drawer__Close').click(function(){
          $('#sidebar-cart').attr('aria-hidden', 'true');
          $('.PageOverlay').removeClass('is-visible');
          $('html').removeClass('no-scroll');
        })
      }, 1000);
    })
  }

  $(".add-all-to-bag").click(function(){
    var currentHtml = $(this).html();
    let banyakItem = $(".list-product-related .item-pr").length;
    // console.log(banyakItem)

    var dataCart = [];
    for (let i = 1; i <= banyakItem; i++) {
      let varId = $(".list-product-related .item-pr.item-"+i+" .ColorSwatch__Radio-js:checked").val()
      var data = {
        id: varId,
        quantity: 1
      }

      var dataIndex = getIndexByProperty(dataCart, 'id', varId);
      if (dataIndex > -1) {
        dataCart[dataIndex] = data;
      } else {
        dataCart.push(data);
      }
    }
    
    var cart = jQuery.post('/cart/add.js', {
      items: dataCart,
    });

    $(this).html("LOADING...");
    $(this).attr("disabled", true);
  
    setTimeout(function(){
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      $("[data-drawer-id=sidebar-cart]").trigger('click')
      $('#sidebar-cart').attr('aria-hidden', 'false');
      $('.PageOverlay').addClass('is-visible');
      $('html').addClass('no-scroll');
      $('#sidebar-cart .Drawer__Close').click(function(){
        $('#sidebar-cart').attr('aria-hidden', 'true');
        $('.PageOverlay').removeClass('is-visible');
        $('html').removeClass('no-scroll');
      })
      $('.add-all-to-bag').html(currentHtml);
    }, 1000);
  })

  var matchFunc = function(passname){
    var maxHeight = 0;
    jQuery(passname).each(function(){
      if (jQuery(this).height() > maxHeight) { maxHeight = jQuery(this).height(); }
      // console.log(maxHeight)
    });

    jQuery(passname).height(maxHeight);
  }

  if(jQuery(".jawaban-community").length > 0){
    setTimeout(() => {
      matchFunc(".jawaban-community .answer-image");
    }, 2000);
    // console.log('comm')
  }

  if(jQuery(".for-shop-menu").length > 0){
    jQuery(".shop-navigation").append(jQuery(".for-shop-menu"))
    jQuery(".for-shop-menu").show();
  }
  /**
  jQuery(document).on("submit", "[action='/cart']", function(e){
    e.preventDefault();

    console.log("clicked")
    
    if (jQuery("[action='/cart'] input[name=agree]").prop("checked") == false){ 
        jQuery(".info-aggree").html("YOU MUST AGREE WITH THE TERMS AND CONDITIONS OF SALES TO CHECK OUT.")
        return false;
    }
    else{
      jQuery(".info-aggree").html("");
      // $.ajax({
      //     type: 'GET',
      //     url: 'https://kivabeauty.co.id/cart.json',
      //     dataType: 'jsonp',
      //     success: function(data) {
      //         var json = JSON.stringify(data);
      //         localStorage.setItem('data-cart', json);
  
      //         if(localStorage.getItem('data-cart')){
      //             console.log(localStorage.getItem('data-cart'))
      //             location.href = `https://www.checkout.devbdd.com/checkout/d/?data=${encodeURIComponent(localStorage.getItem('data-cart'))}&url_unique=ft82tTX9adHe7CPzkxQy`
      //         }
      //     }
      // });

      jQuery.ajax({
          type: 'GET',
          url: '/cart.js',
          cache: false,
          dataType: 'json',
          success: function (cart) {
              var json = JSON.stringify(cart);
              localStorage.setItem('data-cart', json);

              if(localStorage.getItem('data-cart')){
                  location.href = `https://www.checkout.devbdd.com/checkout/d/?data=${encodeURIComponent(localStorage.getItem('data-cart'))}&url_unique=ft82tTX9adHe7CPzkxQy`
              }
          }
      })
      return false;
    }
  })
  */
})